import React from 'react';
import { Slider } from 'antd';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

export default class PercentRangeEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e) {
        this.props.source.value = e;
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    render() {

        return (
            (<Slider
                value={this.props.source.value}
                range={true}
                min={this.props.source.minValue === undefined ? 0 : this.props.source.minValue}
                max={this.props.source.maxValue === undefined ? 100 : this.props.source.maxValue}
                onChange={e => this.onChange(e)}
                tooltip={{
                    formatter: value => value + "%"
                }}
            />)
        );
    }
}

PropertyGridUtils.register("percent-range", (source, propertyGrid) => <PercentRangeEditor source={source} propertyGrid={propertyGrid} />);